import { CartAdapter } from '@spartacus/cart/base/core';
import { Observable } from 'rxjs';

export abstract class CustomCartAdapter extends CartAdapter {
  /**
   * Abstract method to assign an extra data to the cart.
   * @param userId
   * @param cartId
   * @param extraData
   */
  abstract addExtraData(
    userId: string,
    cartId: string,
    extraData: {},
  ): Observable<{}>;
}
